import { render, staticRenderFns } from "./button-info.vue?vue&type=template&id=e802da78&scoped=true&"
import script from "./button-info.vue?vue&type=script&lang=ts&"
export * from "./button-info.vue?vue&type=script&lang=ts&"
import style0 from "./button-info.vue?vue&type=style&index=0&id=e802da78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e802da78",
  null
  
)

export default component.exports